import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import { PropTypes } from 'prop-types';

// Parametros props
//src: donde se encuentra localizada la imagen (Ruta)

CardImage.propTypes = {
    src: PropTypes.string
};

CardImage.defaultProps = {
    src: process.env.PUBLIC_URL + '/csbanner.png'
}

function CardImage(props) {
    return (
        <>
            <Card style={{ margin: 0, padding: 0 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        image={props.src}
                        alt="Home"
                    />
                </CardActionArea>
            </Card>
        </>
    );
}

export default React.memo(CardImage);